import { setInitialLoader, setMainLoading } from "../Store/reducers/Common";
import { setToastData } from "../Store/reducers/Toast";
import { setLogin } from "../Store/reducers/Users";
import { ConvertErrorArrayToString } from "./Common";
import { PostAxios, TokenExpireOnAPIRequest } from "./RequestService";

export const AuthLogin = (fetchAccessToken, dispatch, navigate) => {
  PostAxios(`login-user`, {}, fetchAccessToken)
    .then(({ data }) => {
      if (data.error === "1") {
        dispatch(
          setToastData({
            title:'Error',
            message: (data.errors)?ConvertErrorArrayToString(data.errors):data.message,
            isHtml: true,
            type: "error",
            showCloseBtn: true,
          })
        );
      } else if(data.status === "1") {
        dispatch(
          setLogin({
            userData: data.data,
            accessToken: fetchAccessToken,
          })
        );
        if (data.status === "2") {
          dispatch(
            setToastData({
              title:'Warning',
              message: `Your access has been disabled. Please contact the admin for further details..`,
              type: "warning",
              showCloseBtn: false,
              showLogoutBtn: true,
            })
          );
        }
        if (typeof navigate === "function") {
          navigate();
        }
      }
      dispatch(setInitialLoader(false));
      dispatch(setMainLoading(false));
    })
    .catch((err) => {
      console.log(err);
      TokenExpireOnAPIRequest(dispatch, err);
    });
}